const GROUPED = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

/**
 * Money on operator screens (C4 §8): `50,000₮`; 0 is «Үнэгүй» unless
 * `free: false`; missing is «—». Render with tabular figures.
 */
export function money(n: number | null | undefined, opts: { free?: boolean } = {}): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return "—";
  if (n === 0 && opts.free !== false) return "Үнэгүй";
  return `${GROUPED.format(Math.round(n))}₮`;
}
